import React from "react";
import { Card, Icon, Typography, Box, LinkButton } from "@bca/ui-library";

interface NoBuyingRightsProps {
  text: string;
}

const NoBuyingRights: React.FunctionComponent<NoBuyingRightsProps> = ({
  text,
}) => {
  const registerLink =
    "https://www.bca.co.uk/buy/Join-BCA/Register/Trade-Buyer-Registration/";

  return (
    <Card
      width={["100%", "100%", 650]}
      height="fit-content"
      marginX={0}
      marginY={0}
      paddingY={9}
    >
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Icon
          name="info-circle"
          data-testid="icon-container-info-circle"
          weight="solid"
          width={18}
          height={18}
          color="grey-blue"
        />
        <Typography variant="body" color="grey-blue" mt={1} mb={19}>
          {text}
        </Typography>
        <Box
          display="flex"
          flex={1}
          justifyContent="flex-start"
          alignItems="center"
        >
          <LinkButton
            variant="primary-gradient"
            link={registerLink}
            shouldOpenInNewWindow={false}
            data-label="upgrade-to-buy-online"
            data-action="start"
          >
            Upgrade to buy online
          </LinkButton>
        </Box>
      </Box>
    </Card>
  );
};

export default NoBuyingRights;
